<form
  class="contact-form form-wrapper"
  id="contactusForm"
  [formGroup]="contactusForm"
>
  <div class="form-outline mb-3">
    <!-- <label class="form-label">Name</label> -->
    <input
      type="name"
      id="name"
      formControlName="name"
      class="form-control"
      placeholder="{First Name} {Last Name}"
    />
    <div
      *ngIf="
        contactusForm.controls['name'].touched &&
        contactusForm.controls['name'].invalid
      "
      class="alert alert-danger form-danger error"
      role="alert"
    >
      <span *ngIf="contactusForm.controls.name.errors.required"
        >Name is required.</span
      >
      <span
        *ngIf="
          contactusForm.controls.name.errors.minlength &&
          !contactusForm.controls.name.errors.required
        "
        >Please enter minimum 3 character long name.</span
      >
      <span
        *ngIf="
          contactusForm.controls.name.errors.maxlength &&
          !contactusForm.controls.name.errors.required
        "
        >Please enter maximum 20 character long name.</span
      >
    </div>
  </div>
  <div class="form-outline mb-3">
    <!-- <label class="form-label">Email</label> -->
    <input
      type="email"
      id="email"
      formControlName="email"
      class="form-control"
      placeholder="example@email.com"
    />
    <div
      *ngIf="
        contactusForm.controls['email'].touched &&
        contactusForm.controls['email'].invalid
      "
      class="alert alert-danger form-danger error"
      role="alert"
    >
      <span
        *ngIf="
          contactusForm.controls.email.errors.email ||
          contactusForm.controls.email.errors.required
        "
        >Please provide valid email address.</span
      >
    </div>
  </div>
  <div class="form-outline mb-3">
    <!-- <label class="form-label">Company Name</label> -->
    <input
      type="company_name"
      id="company_name"
      formControlName="company_name"
      class="form-control"
      placeholder="Company Name"
    />
    <div
      *ngIf="
        contactusForm.controls['company_name'].touched &&
        contactusForm.controls['company_name'].invalid
      "
      class="alert alert-danger form-danger error"
      role="alert"
    >
      <span *ngIf="contactusForm.controls.company_name.errors.required"
        >Company Name is required.</span
      >
      <span
        *ngIf="
          contactusForm.controls.company_name.errors.minlength &&
          !contactusForm.controls.company_name.errors.required
        "
        >Please enter minimum 3 character long company name.</span
      >
      <span
        *ngIf="
          contactusForm.controls.company_name.errors.maxlength &&
          !contactusForm.controls.company_name.errors.required
        "
        >Please enter maximum 20 character long company name.</span
      >
    </div>
  </div>
  <div class="form-outline mb-3">
    <!-- <label class="form-label">Write your query</label> -->
    <textarea
      rows="3"
      type="query"
      id="query"
      formControlName="query"
      class="form-control"
      placeholder="Write your query"
    >
Write your query </textarea
    >
    <div
      *ngIf="
        contactusForm.controls['query'].touched &&
        contactusForm.controls['query'].invalid
      "
      class="alert alert-danger form-danger error"
      role="alert"
    >
      <span *ngIf="contactusForm.controls.query.errors.required"
        >Query is required.</span
      >
      <span
        *ngIf="
          contactusForm.controls.query.errors.minlength &&
          !contactusForm.controls.query.errors.required
        "
        >Please enter minimum 3 character long query.</span
      >
      <span
        *ngIf="
          contactusForm.controls.query.errors.maxlength &&
          !contactusForm.controls.query.errors.required
        "
        >Please enter maximum 100 character long query.</span
      >
    </div>
  </div>
  <button
    type="submit"
    class="btn btn-outline-light btn-blue-bg submit-button"
    (click)="submit()"
    [disabled]="!contactusForm.valid && token != undefined"
  >
    Submit
  </button>
</form>
